import React from 'react';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {Translate} from "../../../../config/Translate";
import axios from "axios";
import {defaultVariabls} from "../../../../config/index";
import {withRouter} from "react-router-dom";
import { withSnackbar } from 'notistack';
import AppAnimate from "../../../components/AppAnimate";
import AppCard from "../../../components/layouts/components/AppCard";
import Grid from "@material-ui/core/Grid/Grid";
import {connect, setStore} from "trim-redux";
import BreadCrumbs from "../../../components/elements/BreadCrumbs";
import AppCardLoaderFields from "../../../components/Skeletons/AppCardLoaderFields";
import Typography from "@material-ui/core/Typography/Typography";
import CurrencyFormat from "react-currency-format";
import {currencySymbol, price} from "../../../../config/values";
import LoadingButton from "../../../components/elements/LoadingButton";
import DepositMoneyDialog from "../../wallet/DepositMoneyDialog";
import {updateRedux} from "../../../../config/Security";
import SubTitle from "../../../components/elements/SubTitle";
import moment from "jalali-moment";
import SingleOrderItem from "../components/SingleOrderItem";
import Divider from "@material-ui/core/Divider/Divider";
import FiberManualRecordRoundedIcon from '@material-ui/icons/FiberManualRecordRounded';
import Button from "@material-ui/core/Button/Button";
import ChevronLeftRoundedIcon from '@material-ui/icons/ChevronLeftRounded';
class ViewOrder extends React.Component {

    state = {
        factor:null,
        SubmitLoading:false,
        id:this.props.match.params.id,
        loading:true
    };
    classes = this.props.classes;
    async componentDidMount(){
        await this.loadData();

    }
    componentDidUpdate(prevProps){
        if(this.state.id !== this.props.match.params.id){
            this.setState({
                id: this.props.match.params.id
            })
        }
    }
    async loadData(){
        let loginToken = localStorage.getItem('ACT');
        if(loginToken !== null){
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            await axios.get(`${defaultVariabls.url}/factor/get/${this.state.id}`, config)
                .then(response => {
                    console.log(response.data)
                    this.setState({
                        factor:response.data,
                        loading:false
                    })

                }).catch(error => {
                    console.log(error.response)
                    this.setState({
                        loading:false
                    })
                })
        }else {
            setStore({
                isAuth : false,
                user : null,
            });
        }
    }
    async handleRequest(){
        let { id} = this.state;
        let data = new FormData();
        data.append('id', id);

        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        await axios.post(`${defaultVariabls.url}/factor/pay`, data, config)
            .then(response => {
                this.props.enqueueSnackbar(Translate.orderPayed, {
                    variant: 'success',
                });
                updateRedux();
                this.setState({
                    loading:true,
                    SubmitLoading: false,
                });
                this.loadData();

            })
            .catch(error => {
                console.log(error.response)
                this.props.enqueueSnackbar(Translate.orderPayingFailed, {
                    variant: 'error',
                });
                this.setState({
                    loading:false,
                    SubmitLoading: false,
                    SubmitDraftLoading: false
                });
            });

    }
    async handleRequestDirect(){
        let {factor} = this.state;
        this.setState({
            SubmitLoading: true
        })
        window.open(`${defaultVariabls.website}/order/pay/${factor.id}`,'_self')
    }

    handleSubmit(e){
        this.setState({
            SubmitLoading: true
        })
        this.handleRequest();

    }
    render(){
        let {factor,SubmitLoading} = this.state;
        let total_price,wallet_amount,can_pay_with_wallet,transfer_price;
        if(!!factor){
            total_price = factor.total_price_payed;
            transfer_price = factor.transfer_price;
            wallet_amount = this.props.user.wallet.amount;
            can_pay_with_wallet = wallet_amount >= total_price;
        }
        return (
            <AppAnimate animation='transition.slideUpIn' delay={200} title={Translate.viewOrder}>
                {

                    <Grid container spacing={2} justify="center">
                        <Grid item xs={12} md={8} lg={9}>
                            <AppCard
                                title={Translate.viewOrder}
                                action={
                                    <BreadCrumbs  firstText={Translate.orders} firstLink="/my-orders" secondText={Translate.viewOrder}/>
                                }>
                                {
                                    this.state.loading ?
                                        <AppCardLoaderFields/>
                                        :
                                        <Grid container spacing={2} justify="center" alignItems="center">
                                            <Grid item xs={12} style={{display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                                                <SubTitle align="left">{Translate.orderDetails}</SubTitle>

                                                {
                                                    factor.status !== "not_payed" &&
                                                    <Button
                                                        color="primary"
                                                        component={"a"}
                                                        href={`${defaultVariabls.website}/view/invoice/${factor.number}`}
                                                        target="_blank"
                                                        size="small"
                                                        variant="outlined"
                                                        startIcon={<ChevronLeftRoundedIcon/>}
                                                    >
                                                        {Translate.viewInvoice}
                                                    </Button>
                                                }
                                            </Grid>
                                            <Grid item xs={12}>
                                                <div className="order-items-holder">
                                                    <Typography>{Translate.order_status} <span className="result" style={{color: factor.status === "not_payed" ? "#f82e4e" : ''}}>{Translate[factor.status]}</span> </Typography>
                                                    <Typography>
                                                        <FiberManualRecordRoundedIcon fontSize="small"/>
                                                    </Typography>
                                                    <Typography>{Translate.factor_number} <span className="result">{factor.number}</span></Typography>
                                                    <Typography>
                                                        <FiberManualRecordRoundedIcon fontSize="small"/>
                                                    </Typography>
                                                    <Typography>
                                                        {Translate.created_at_factor}
                                                        <span className="result">
                                                            {`${moment(factor.created_at).locale('fa').format( 'YYYY/M/D')}`}
                                                        </span>
                                                    </Typography>
                                                </div>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Divider/>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <div className="order-items-holder mb-15">
                                                    <Typography>{Translate.user_delivery} <span className="result">{factor.user.first_name} {factor.user.last_name}</span></Typography>
                                                    <Typography>
                                                        <FiberManualRecordRoundedIcon fontSize="small"/>
                                                    </Typography>
                                                    <Typography>{Translate.mobileNumber} <span className="result">{factor.user.mobile}</span></Typography>
                                                </div>
                                                <div className="order-items-holder">
                                                    <Typography>{Translate.address} <span className="result">{factor.address.province} / {factor.address.city}، {factor.address.address}، {Translate.postal_code} {factor.address.postal_code}.  </span></Typography>
                                                </div>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Divider/>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <div className="order-items-holder">
                                                    <Typography>{Translate.priceName}<span className="result">{price(factor.total_price_payed - factor.transfer_price)} {currencySymbol}</span></Typography>
                                                    <Typography>
                                                        <FiberManualRecordRoundedIcon fontSize="small"/>
                                                    </Typography>
                                                    <Typography>{Translate.transferPrice}<span className="result">{price(factor.transfer_price)} {currencySymbol}</span></Typography>
                                                    <Typography>
                                                        <FiberManualRecordRoundedIcon fontSize="small"/>
                                                    </Typography>
                                                    <Typography>{Translate.totalDiscounts} <span className="result"> {price(factor.total_discount_code_price + factor.total_discount_price)} {currencySymbol}</span></Typography>
                                                </div>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <SubTitle align="left">{Translate.productsList}</SubTitle>
                                            </Grid>
                                            <Grid item xs={12}>
                                                {
                                                    factor.order_items.map((item,index) => (
                                                        <SingleOrderItem factor_status={factor.status} key={index} item={item} view/>
                                                    ))
                                                }
                                            </Grid>
                                        </Grid>
                                }
                            </AppCard>
                        </Grid>
                        {
                            !this.state.loading &&
                            factor.status === "not_payed" &&
                            <Grid item xs={12} md={4} lg={3} className="text-center">
                                <AppCard
                                    title={Translate.purchase}
                                >
                                    {
                                        this.state.loading ?
                                            <AppCardLoaderFields/>
                                            :
                                            <>
                                                <Typography paragraph color="primary">{Translate.payableMoney}: <strong><CurrencyFormat
                                                    value={factor.total_price_payed} displayType={'text'}
                                                    thousandSeparator={true}
                                                    suffix={" " + currencySymbol}/></strong></Typography>
                                                <Typography color="secondary" variant="body2"
                                                            style={{marginBottom: 10}}>{Translate.myWalletBalance}: <strong><CurrencyFormat
                                                    value={wallet_amount} displayType={'text'} thousandSeparator={true}
                                                    suffix={" " + currencySymbol}/></strong></Typography>
                                                <LoadingButton
                                                    variant="contained"
                                                    color="secondary"
                                                    styleForParent={{marginBottom: 10,marginTop:15}}
                                                    style={{width: "100%"}}
                                                    onClick={this.handleRequestDirect.bind(this)}
                                                    loading={SubmitLoading}
                                                >
                                                    {Translate.payOrder}
                                                </LoadingButton>
                                                {
                                                    can_pay_with_wallet ?
                                                    <LoadingButton
                                                        variant="contained"
                                                        color="secondary"
                                                        disabled={!can_pay_with_wallet}
                                                        styleForParent={{marginBottom: 10,marginTop:15}}
                                                        style={{width: "100%"}}
                                                        onClick={this.handleSubmit.bind(this)}
                                                        loading={SubmitLoading}
                                                    >
                                                        {Translate.payWithWallet}
                                                    </LoadingButton> :
                                                        <DepositMoneyDialog
                                                            purchase
                                                            amount={factor.total_price_payed}
                                                            variant="text"
                                                            redirect={`/order/view/${factor.id}`}
                                                            style={{width:"100%"}}
                                                        />
                                                }

                                            </>
                                    }
                                </AppCard>
                            </Grid>
                        }
                    </Grid>
                }
            </AppAnimate>

        );
    }
}
const mstp = state => ({
    user: state.user,
});
export default withSnackbar(withRouter(withStyles(Styles)(connect(mstp)(ViewOrder))));